import styled from 'styled-components';
import { TypographyStyles } from '../../../../stylings';

export const Price = styled.span`
  ${TypographyStyles.Body.Small.SemiBold}
`;
